import { useState } from 'react';
import { buildInfo, versionLabel } from '../../buildInfo';
import { cn } from '../../lib/utils';

/**
 * Subtle build stamp in the sidebar footer. Shows `v<version> · <commit>`; the full
 * build time + branch is in the tooltip, and clicking copies the complete build info
 * (handy when a user reports something and we need to know exactly what they were on).
 * Collapsed rail shows just the version to fit the 4rem column.
 */
export function VersionBadge({ collapsed }: { collapsed: boolean }) {
  const [copied, setCopied] = useState(false);

  const detail = `Fluent MedOps Clinical\nversion ${buildInfo.version}\ncommit ${buildInfo.commit}\nbranch ${buildInfo.branch}\nbuilt ${buildInfo.buildTime}`;
  const tooltip = `${versionLabel}\n${buildInfo.branch} · built ${buildInfo.buildTime}`;

  const copy = () => {
    void navigator.clipboard
      ?.writeText(detail)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => {
        /* clipboard blocked — tooltip still shows the details */
      });
  };

  return (
    <button
      type="button"
      onClick={copy}
      title={tooltip}
      aria-label={`Build ${versionLabel}. Click to copy build details.`}
      data-testid="version-badge"
      className={cn(
        'w-full truncate px-3 py-1 text-left font-mono text-[11px] leading-tight text-muted-foreground/70 hover:text-muted-foreground',
        collapsed && 'px-0 text-center'
      )}
    >
      {copied ? 'Copied' : collapsed ? `v${buildInfo.version}` : versionLabel}
    </button>
  );
}

export default VersionBadge;
